// extracted by mini-css-extract-plugin
module.exports = {"container":"_d132349","brand":"_4f6885c","text":"_ed2280e","logo":"_140cc43","info":"_1bcc06d","time":"_20fae67","button":"_21fae94"};